import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=53529200&scoped=true&lang=pug"
import script from "./ItemsList.vue?vue&type=script&lang=js"
export * from "./ItemsList.vue?vue&type=script&lang=js"
import style0 from "./ItemsList.vue?vue&type=style&index=0&id=53529200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53529200",
  null
  
)

export default component.exports